export default __webpack_public_path__ + "static/media/smart-tent-r.80c98d36.jpeg";